// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__BXod2","selected":"Menu_selected__XSp2W","brand_box":"Menu_brand_box__SfN-C","user_box":"Menu_user_box__pLhJ8","version_box":"Menu_version_box__+VN8c"};